// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/katex/dist/katex.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/nprogress/nprogress.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/svgs/variable-link.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w100 {
  width: 100%;
}
.h100 {
  height: 100%;
}
.border {
  border: 1px solid #DDDDDE;
  border-radius: 5px;
}
.border-left {
  border-left: 1px solid #DDDDDE;
}
.border-right {
  border-right: 1px solid #DDDDDE;
}
.border-top {
  border-top: 1px solid #DDDDDE;
}
.border-bottom {
  border-bottom: 1px solid #DDDDDE;
}
@media print {
  .no-print {
    display: none !important;
  }
}
.setting-menu {
  background: none;
  border-right: none;
}
.setting-menu .ant-menu-item-group-title {
  padding: 2px 0 2px 8px !important;
  color: #333333;
  font-weight: bold;
}
.setting-menu .ant-menu-item {
  padding-left: 8px !important;
  color: #7D8592;
}
.setting-menu .ant-menu-item-selected {
  color: '#037C4B';
}
.bg-container {
  width: 100%;
  padding: 8px;
  background: #f9fbfc;
  border-radius: 5px;
}
.center-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.common-dialog-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.common-dialog-title .common-dialog-title-icon {
  width: 24px;
  height: 24px;
  background-color: #eee;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #333;
}
.common-dialog-title .common-dialog-title-icon > .anticon {
  margin: auto;
  font-size: 20px;
}
.common-dialog-title .common-dialog-title-icon > img {
  width: 20px;
  height: 20px;
}
.common-dialog-title .common-dialog-title-text {
  flex: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table {
  width: 100%;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
a.link {
  color: #666;
}
a.link:hover {
  color: '#037C4B';
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-col-center {
  display: flex;
  align-items: center;
}
.flex-space-btw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.svg-preview img {
  width: 100%;
  height: 100%;
}
.absolute {
  position: absolute;
}
.backdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
.editable-cell-value-wrap {
  cursor: pointer;
  width: 100px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  min-height: 32px;
}
.editable-cell-value-wrap:hover {
  border-color: #d9d9d9;
  border-radius: 2px;
}
.bordered {
  border: 1px solid #ddd;
}
.text-center {
  text-align: center;
}
.hover-delete-container:hover .hover-delete {
  display: block !important;
  cursor: pointer;
}
.icon-button-disabled {
  color: #aaa !important;
  cursor: default !important;
}
.icon-button-disabled .antd-icon,
.icon-button-disabled .iconfont,
.icon-button-disabled .anticon {
  color: #aaa !important;
}
.full-screen {
  width: 100vw;
  height: 100vh;
}
.d-block {
  display: block;
}
.full-div {
  width: 100%;
  height: 100%;
}
.svg-image {
  display: flex;
  align-items: center;
  justify-content: center;
}
.osize-elem {
  position: absolute;
  z-index: -1;
  visibility: hidden;
}
.fs-svg-node {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.svg-node-icon {
  max-width: 100%;
  max-height: 100%;
}
.cell-sim-error path {
  stroke: red !important;
}
.cell-sim-warn path {
  stroke: #f2b202 !important;
}
.svg-shake .fs-svg-node.shake-node {
  animation: shake 0.5s ease-in-out infinite;
}
@keyframes shake {
  0%,
  100% {
    transform: translateY(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateY(-5px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateY(5px);
  }
}
.text-center {
  text-align: center;
}
.ql-view-container p,
.ql-editor p {
  line-height: 1;
  font-size: 14px;
}
.ql-line-height.ql-picker {
  min-width: 60px;
}
.ql-picker-item[data-value="0.4"]::before,
.ql-picker-label[data-value="0.4"]::before {
  content: '0.4' !important;
}
.ql-picker-item[data-value="0.6"]::before,
.ql-picker-label[data-value="0.6"]::before {
  content: '0.6' !important;
}
.ql-picker-item[data-value="0.8"]::before,
.ql-picker-label[data-value="0.8"]::before {
  content: '0.8' !important;
}
.ql-picker-item[data-value="1.0"]::before,
.ql-picker-label[data-value="1.0"]::before {
  content: '1.0' !important;
}
.ql-picker-item[data-value="1.2"]::before,
.ql-picker-label[data-value="1.2"]::before {
  content: '1.2' !important;
}
.ql-picker-item[data-value="1.5"]::before,
.ql-picker-label[data-value="1.5"]::before {
  content: '1.5' !important;
}
.ql-picker-item[data-value="2.0"]::before,
.ql-picker-label[data-value="2.0"]::before {
  content: '2.0' !important;
}
.printContent {
  display: none;
}
@media print {
  .printContent {
    display: block;
  }
  .printContent .noPrint {
    display: none;
  }
  .printContent .x6-graph-svg {
    position: static !important;
    left: auto;
    right: auto;
    top: auto;
    bottom: auto;
  }
}
.main-menu {
  background-color: #1A8D5F;
}
.main-menu .ant-menu-title-content,
.main-menu .ant-menu-title-content > a {
  color: #fff;
}
.main-menu .ant-menu-overflow-item,
.main-menu .ant-menu-submenu-title {
  align-items: center;
  display: flex;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.view-form table td,
.design-table table td,
.view-form table th,
.design-table table th {
  border: 1px solid #eee;
  /* padding:10px; */
  empty-cells: show;
}
.hide-outer-border .view-form-table tr:first-child > td {
  border-top: none;
}
.hide-outer-border .view-form-table tr:last-child > td {
  border-bottom: none;
}
.hide-outer-border .view-form-table tr > td:first-child {
  border-left: none;
}
.hide-outer-border .view-form-table tr > td:last-child {
  border-right: none;
}
.d-forms .forms-header tr:first-child > td,
.d-forms .forms-content tr:first-child > td {
  border-top: none;
}
.d-forms .forms-header tr > td:first-child,
.d-forms .forms-content tr > td:first-child {
  border-left: none;
}
.d-forms .forms-header tr > td:last-child,
.d-forms .forms-content tr > td:last-child {
  border-right: none;
}
.mt-0 {
  margin-top: 0px !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
.ml-0 {
  margin-left: 0px !important;
}
.mr-0 {
  margin-right: 0px !important;
}
.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.m-0 {
  margin: 0px !important;
}
.mt-1 {
  margin-top: 8px !important;
}
.mb-1 {
  margin-bottom: 8px !important;
}
.ml-1 {
  margin-left: 8px !important;
}
.mr-1 {
  margin-right: 8px !important;
}
.mx-1 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.my-1 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.m-1 {
  margin: 8px !important;
}
.mt-2 {
  margin-top: 16px !important;
}
.mb-2 {
  margin-bottom: 16px !important;
}
.ml-2 {
  margin-left: 16px !important;
}
.mr-2 {
  margin-right: 16px !important;
}
.mx-2 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}
.my-2 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}
.m-2 {
  margin: 16px !important;
}
.mt-3 {
  margin-top: 24px !important;
}
.mb-3 {
  margin-bottom: 24px !important;
}
.ml-3 {
  margin-left: 24px !important;
}
.mr-3 {
  margin-right: 24px !important;
}
.mx-3 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.my-3 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}
.m-3 {
  margin: 24px !important;
}
.mt-4 {
  margin-top: 32px !important;
}
.mb-4 {
  margin-bottom: 32px !important;
}
.ml-4 {
  margin-left: 32px !important;
}
.mr-4 {
  margin-right: 32px !important;
}
.mx-4 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}
.my-4 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}
.m-4 {
  margin: 32px !important;
}
.pt-0 {
  padding-top: 0px !important;
}
.pb-0 {
  padding-bottom: 0px !important;
}
.pl-0 {
  padding-left: 0px !important;
}
.pr-0 {
  padding-right: 0px !important;
}
.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.p-0 {
  padding: 0px !important;
}
.pt-1 {
  padding-top: 8px !important;
}
.pb-1 {
  padding-bottom: 8px !important;
}
.pl-1 {
  padding-left: 8px !important;
}
.pr-1 {
  padding-right: 8px !important;
}
.px-1 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.py-1 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.p-1 {
  padding: 8px !important;
}
.pt-2 {
  padding-top: 16px !important;
}
.pb-2 {
  padding-bottom: 16px !important;
}
.pl-2 {
  padding-left: 16px !important;
}
.pr-2 {
  padding-right: 16px !important;
}
.px-2 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.py-2 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.p-2 {
  padding: 16px !important;
}
.pt-3 {
  padding-top: 24px !important;
}
.pb-3 {
  padding-bottom: 24px !important;
}
.pl-3 {
  padding-left: 24px !important;
}
.pr-3 {
  padding-right: 24px !important;
}
.px-3 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.py-3 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.p-3 {
  padding: 24px !important;
}
.pt-4 {
  padding-top: 32px !important;
}
.pb-4 {
  padding-bottom: 32px !important;
}
.pl-4 {
  padding-left: 32px !important;
}
.pr-4 {
  padding-right: 32px !important;
}
.px-4 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
.py-4 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}
.p-4 {
  padding: 32px !important;
}
.container-sm {
  max-width: 544px;
  margin-right: auto;
  margin-left: auto;
}
.container-md {
  max-width: 768px;
  margin-right: auto;
  margin-left: auto;
}
.container-lg {
  max-width: 1004px;
  margin-right: auto;
  margin-left: auto;
}
.container-xl {
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
}
.actionRow {
  display: flex;
  padding: 5px 10px;
  justify-content: flex-end;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.ant-tabs-tab .ant-btn-group button {
  border: none;
  outline: none;
  background: none;
  box-shadow: none;
}
.ant-tree-iconEle img {
  width: 100%;
  height: 100%;
}
.otree-menu {
  max-height: 400px;
  overflow-y: auto;
}
.ant-table.ant-table-bordered > .ant-table-title {
  background: #fafafa;
}
.ant-btn-sm {
  font-size: 12px;
}
.ant-tree-list-holder-inner {
  display: inline-flex !important;
  min-width: 100%;
}
.ant-tree-node-content-wrapper {
  white-space: nowrap;
}
.ant-modal-title {
  white-space: nowrap;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.orbit-context-menu .ant-menu-submenu-title,
.orbit-context-menu .ant-menu-submenu-title,
.orbit-context-menu .ant-menu-item {
  height: 26px !important;
  line-height: 26px !important;
}
.break-word-table th,
.break-word-table td {
  word-wrap: break-word;
}
.table-mt {
  margin-top: 16px;
}
.bordered-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}
.bordered-table th,
.bordered-table td {
  border: 1px solid #eee;
  padding: 4px;
  text-align: center;
}
.bordered-table th {
  background-color: #fafafa;
}
.bordered-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.bordered-table.same-color tr:nth-child(even) {
  background-color: inherit !important;
}
.orbit-variable-cell {
  position: relative;
}
.orbit-variable-cell.manual-var {
  color: #037C4B;
}
.orbit-cell {
  padding: 0 !important;
}
.orbit-cell-div {
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.orbit-formula-cell {
  background-color: bisque;
}
.jtabs-headers-container {
  display: none !important;
}
.orbit-variable-cell {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right top;
  background-repeat: no-repeat;
}
.formula-cell {
  border-color: #037C4B;
}
.editableDiv {
  width: 100%;
}
.totalFraction {
  border: 1px solid #ddd;
  padding: 5px 10px;
  display: inline-block;
  width: 100px;
}
.errorStatus {
  color: red;
}
.manualInputRow {
  color: #1677ff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/common.less","webpack://./src/App.less","webpack://./src/styles/view-form.less","webpack://./src/styles/mixin.less","webpack://./src/styles/container.less","webpack://./src/styles/reset.less","webpack://./src/styles/table.less","webpack://./src/styles/spreadsheet.less","webpack://./src/styles/flow-unit.less"],"names":[],"mappings":"AAGA;EACE,WAAA;ACAF;ADGA;EACE,YAAA;ACDF;ADIA;EACE,yBAAA;EACA,kBAAA;ACFF;ADKA;EACE,8BAAA;ACHF;ADMA;EACE,+BAAA;ACJF;ADOA;EACE,6BAAA;ACLF;ADQA;EACE,gCAAA;ACNF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;ADUA;EACE,gBAAA;EACA,kBAAA;ACRF;ADMA;EAKI,iCAAA;EACA,cAAA;EACA,iBAAA;ACRJ;ADCA;EAWI,4BAAA;EACA,cAAA;ACTJ;ADHA;EAgBI,gBAAA;ACVJ;ADcA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ACZF;ADeA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACbF;ADgBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ACdF;ADWA;EAMI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;ACdJ;ADgBI;EACE,YAAA;EACA,eAAA;ACdN;ADiBI;EACE,WAAA;EACA,YAAA;ACfN;ADRA;EA4BI,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACjBJ;ADqBA;EACE,WAAA;ACnBF;ADsBA;EACE,yBAAA;EACA,mBAAA;ACpBF;ADuBA;EACE,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;ACrBF;ADwBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;ACtBF;ADyBA;EACE,WAAA;ACvBF;ADwBE;EACE,gBAAA;ACtBJ;AD0BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ACxBF;AD2BA;EACE,aAAA;EACA,mBAAA;ACzBF;AD4BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AC1BF;AD6BA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AC3BF;AD8BA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AC5BF;AD+BA;EACE,WAAA;EACA,YAAA;AC7BF;ADgCA;EACE,kBAAA;AC9BF;ADiCA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;AC/BF;ADkCA;EACE,eAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AChCF;ADmCA;EACE,qBAAA;EACA,kBAAA;ACjCF;ADoCA;EACE,sBAAA;AClCF;ADqCA;EACE,kBAAA;ACnCF;ADsCA;EAEI,yBAAA;EACA,eAAA;ACrCJ;ADyCA;EACE,sBAAA;EACA,0BAAA;ACvCF;ADqCA;;;EAKI,sBAAA;ACrCJ;AD0CA;EACE,YAAA;EACA,aAAA;ACxCF;AD2CA;EACE,cAAA;ACzCF;AD4CA;EACE,WAAA;EACA,YAAA;AC1CF;AD6CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AC3CF;AD8CA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AC5CF;AD+CA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AC7CF;ADgDA;EACE,eAAA;EACA,gBAAA;AC9CF;ADiDA;EAEI,sBAAA;AChDJ;ADoDA;EAEI,0BAAA;ACnDJ;ADuDA;EAEI,0CAAA;ACtDJ;AD0DA;EACE;;IACE,wBAAA;ECvDF;EDyDA;;;;;IACE,2BAAA;ECnDF;EDqDA;;;;IACE,0BAAA;EChDF;AACF;ADmDA;EACE,kBAAA;ACjDF;ADoDA;;EAEI,cAAA;EACA,eAAA;AClDJ;ADsDA;EAA4B,eAAA;ACnD5B;ADoDA;;EAEC,yBAAA;AClDD;ADoDA;;EAEC,yBAAA;AClDD;ADoDA;;EAEC,yBAAA;AClDD;ADqDA;;EAEC,yBAAA;ACnDD;ADsDA;;EAEC,yBAAA;ACpDD;ADsDA;;EAEC,yBAAA;ACpDD;ADsDA;;EAEC,yBAAA;ACpDD;ADuDA;EACE,aAAA;ACrDF;ADuDE;EAAA;IACE,cAAA;ECpDF;EDmDA;IAII,aAAA;ECpDJ;EDgDA;IAQI,2BAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;ECrDJ;AACF;ADyDA;EACE,yBAAA;ACvDF;ADsDA;;EAII,WAAA;ACtDJ;ADkDA;;EAQI,mBAAA;EACA,aAAA;ACtDJ;ACvTA;EACE,yBAAA;EACA,iBAAA;ADyTF;ACtTA;;;;EAII,sBAAA;EDwTF,kBAAkB;ECtThB,iBAAA;ADwTJ;ACpTA;EAEI,gBAAA;ADqTJ;ACvTA;EAKI,mBAAA;ADqTJ;AC1TA;EASI,iBAAA;ADoTJ;AC7TA;EAaI,kBAAA;ADmTJ;AC/SA;;EAEI,gBAAA;ADiTJ;ACnTA;;EAMI,iBAAA;ADiTJ;ACvTA;;EAUI,kBAAA;ADiTJ;AE1VG;EACC,0BAAA;AF4VJ;AEzVG;EACC,6BAAA;AF2VJ;AExVG;EACC,2BAAA;AF0VJ;AEvVG;EACC,4BAAA;AFyVJ;AEtVG;EACC,2BAAA;EACA,4BAAA;AFwVJ;AErVG;EACC,0BAAA;EACA,6BAAA;AFuVJ;AEpVG;EACC,sBAAA;AFsVJ;AEjXG;EACC,0BAAA;AFmXJ;AEhXG;EACC,6BAAA;AFkXJ;AE/WG;EACC,2BAAA;AFiXJ;AE9WG;EACC,4BAAA;AFgXJ;AE7WG;EACC,2BAAA;EACA,4BAAA;AF+WJ;AE5WG;EACC,0BAAA;EACA,6BAAA;AF8WJ;AE3WG;EACC,sBAAA;AF6WJ;AExYG;EACC,2BAAA;AF0YJ;AEvYG;EACC,8BAAA;AFyYJ;AEtYG;EACC,4BAAA;AFwYJ;AErYG;EACC,6BAAA;AFuYJ;AEpYG;EACC,4BAAA;EACA,6BAAA;AFsYJ;AEnYG;EACC,2BAAA;EACA,8BAAA;AFqYJ;AElYG;EACC,uBAAA;AFoYJ;AE/ZG;EACC,2BAAA;AFiaJ;AE9ZG;EACC,8BAAA;AFgaJ;AE7ZG;EACC,4BAAA;AF+ZJ;AE5ZG;EACC,6BAAA;AF8ZJ;AE3ZG;EACC,4BAAA;EACA,6BAAA;AF6ZJ;AE1ZG;EACC,2BAAA;EACA,8BAAA;AF4ZJ;AEzZG;EACC,uBAAA;AF2ZJ;AEtbG;EACC,2BAAA;AFwbJ;AErbG;EACC,8BAAA;AFubJ;AEpbG;EACC,4BAAA;AFsbJ;AEnbG;EACC,6BAAA;AFqbJ;AElbG;EACC,4BAAA;EACA,6BAAA;AFobJ;AEjbG;EACC,2BAAA;EACA,8BAAA;AFmbJ;AEhbG;EACC,uBAAA;AFkbJ;AEzaG;EACC,2BAAA;AF2aJ;AExaG;EACC,8BAAA;AF0aJ;AEvaG;EACC,4BAAA;AFyaJ;AEtaG;EACC,6BAAA;AFwaJ;AEraG;EACC,4BAAA;EACA,6BAAA;AFuaJ;AEpaG;EACC,2BAAA;EACA,8BAAA;AFsaJ;AEnaG;EACC,uBAAA;AFqaJ;AEhcG;EACC,2BAAA;AFkcJ;AE/bG;EACC,8BAAA;AFicJ;AE9bG;EACC,4BAAA;AFgcJ;AE7bG;EACC,6BAAA;AF+bJ;AE5bG;EACC,4BAAA;EACA,6BAAA;AF8bJ;AE3bG;EACC,2BAAA;EACA,8BAAA;AF6bJ;AE1bG;EACC,uBAAA;AF4bJ;AEvdG;EACC,4BAAA;AFydJ;AEtdG;EACC,+BAAA;AFwdJ;AErdG;EACC,6BAAA;AFudJ;AEpdG;EACC,8BAAA;AFsdJ;AEndG;EACC,6BAAA;EACA,8BAAA;AFqdJ;AEldG;EACC,4BAAA;EACA,+BAAA;AFodJ;AEjdG;EACC,wBAAA;AFmdJ;AE9eG;EACC,4BAAA;AFgfJ;AE7eG;EACC,+BAAA;AF+eJ;AE5eG;EACC,6BAAA;AF8eJ;AE3eG;EACC,8BAAA;AF6eJ;AE1eG;EACC,6BAAA;EACA,8BAAA;AF4eJ;AEzeG;EACC,4BAAA;EACA,+BAAA;AF2eJ;AExeG;EACC,wBAAA;AF0eJ;AErgBG;EACC,4BAAA;AFugBJ;AEpgBG;EACC,+BAAA;AFsgBJ;AEngBG;EACC,6BAAA;AFqgBJ;AElgBG;EACC,8BAAA;AFogBJ;AEjgBG;EACC,6BAAA;EACA,8BAAA;AFmgBJ;AEhgBG;EACC,4BAAA;EACA,+BAAA;AFkgBJ;AE/fG;EACC,wBAAA;AFigBJ;AGhkBA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AHkkBF;AG9jBA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AHgkBF;AG5jBA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;AH8jBF;AG1jBA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;AH4jBF;AGzjBA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;AH2jBF;AI1lBA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AJ4lBF;AIzlBA;EAGM,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AJylBN;AIplBA;EAEI,WAAA;EACA,YAAA;AJqlBJ;AIjlBA;EACE,iBAAA;EACA,gBAAA;AJmlBF;AIhlBA;EACE,mBAAA;AJklBF;AI/kBA;EACE,eAAA;AJilBF;AI9kBA;EACE,+BAAA;EACA,eAAA;AJglBF;AI7kBA;EACE,mBAAA;AJ+kBF;AI5kBA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AJ8kBF;AI3kBA;;;EAEI,uBAAA;EACA,4BAAA;AJ8kBJ;AKtoBA;;EAEI,qBAAA;ALwoBJ;AKpoBA;EACE,gBAAA;ALsoBF;AKnoBA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;ALqoBF;AKloBA;;EAEE,sBAAA;EACA,YAAA;EACA,kBAAA;ALooBF;AKjoBA;EACE,yBAAA;ALmoBF;AKhoBA;EACE,yBAAA;ALkoBF;AK/nBA;EACE,oCAAA;ALioBF;AMhqBA;EACE,kBAAA;ANkqBF;AMhqBE;EACE,cAAA;ANkqBJ;AM9pBA;EACE,qBAAA;ANgqBF;AM7pBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AN+pBF;AM5pBA;EACE,wBAAA;AN8pBF;AM3pBA;EACE,wBAAA;AN6pBF;AM1pBA;EACE,yDAAA;EACA,8BAAA;EACA,4BAAA;AN4pBF;AMzpBA;EACE,qBAAA;AN2pBF;AO9rBA;EACE,WAAA;APgsBF;AO7rBA;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AP+rBF;AO5rBA;EACE,UAAA;AP8rBF;AO5rBA;EACE,cAAA;AP8rBF","sourcesContent":["\n@import 'var';\n\n.w100 {\n  width: 100%;\n}\n\n.h100 {\n  height: 100%;\n}\n\n.border {\n  border: 1px solid @border-color-base;\n  border-radius: 5px;\n}\n\n.border-left {\n  border-left: 1px solid @border-color-base;\n}\n\n.border-right {\n  border-right: 1px solid @border-color-base;\n}\n\n.border-top {\n  border-top: 1px solid @border-color-base;\n}\n\n.border-bottom {\n  border-bottom: 1px solid @border-color-base;\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n}\n\n.setting-menu {\n  background: none;\n  border-right: none;\n\n  .ant-menu-item-group-title {\n    padding: 2px 0 2px 8px !important;\n    color: @text-color;\n    font-weight: bold;\n  }\n\n  .ant-menu-item {\n    padding-left: 8px !important;\n    color: @text-color-secondary;\n  }\n\n  .ant-menu-item-selected {\n    color: @primary-color;\n  }\n}\n\n.bg-container {\n  width: 100%;\n  padding: 8px;\n  background: #f9fbfc;\n  border-radius: 5px;\n}\n\n.center-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.common-dialog-title {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n\n  .common-dialog-title-icon {\n    width: 24px;\n    height: 24px;\n    background-color: #eee;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #333;\n\n    & > .anticon {\n      margin: auto;\n      font-size: 20px;\n    }\n\n    & > img {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .common-dialog-title-text {\n    flex: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.table {\n  width: 100%;\n}\n\ntable {\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\na.link {\n  color: #666;\n  &:hover {\n    color: @primary-color;\n  }\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-col-center {\n  display: flex;\n  align-items: center;\n}\n\n.flex-space-btw {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.svg-preview img {\n  width: 100%;\n  height: 100%;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.backdrop {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.editable-cell-value-wrap {\n  cursor: pointer;\n  width: 100px;\n  border: 1px solid transparent;\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n}\n\n.editable-cell-value-wrap:hover {\n  border-color: #d9d9d9;\n  border-radius: 2px;\n}\n\n.bordered {\n  border: 1px solid #ddd;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.hover-delete-container:hover {\n  .hover-delete {\n    display: block !important;\n    cursor: pointer;\n  }\n}\n\n.icon-button-disabled {\n  color: #aaa !important;\n  cursor: default !important;\n\n  .antd-icon, .iconfont, .anticon {\n    color: #aaa !important;\n  }\n\n}\n\n.full-screen {\n  width: 100vw;\n  height: 100vh;\n}\n\n.d-block {\n  display: block;\n}\n\n.full-div {\n  width: 100%;\n  height: 100%;\n}\n\n.svg-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.osize-elem {\n  position: absolute;\n  z-index: -1;\n  visibility: hidden;\n}\n\n.fs-svg-node {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.svg-node-icon {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.cell-sim-error {\n  path {\n    stroke: red !important;\n  }\n}\n\n.cell-sim-warn {\n  path {\n    stroke: #f2b202 !important;\n  }\n}\n\n.svg-shake {\n  .fs-svg-node.shake-node {\n    animation: shake 0.5s ease-in-out infinite;\n  }\n}\n\n@keyframes shake {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateY(-5px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateY(5px);\n  }\n}\n\n.text-center {\n  text-align: center;\n}\n\n.ql-view-container, .ql-editor {\n  p {\n    line-height: 1;\n    font-size: 14px;\n  }\n}\n\n.ql-line-height.ql-picker { min-width: 60px }\n.ql-picker-item[data-value=\"0.4\"]::before,\n.ql-picker-label[data-value=\"0.4\"]::before {\n content: '0.4'!important ;\n}\n.ql-picker-item[data-value=\"0.6\"]::before,\n.ql-picker-label[data-value=\"0.6\"]::before {\n content: '0.6'!important ;\n}\n.ql-picker-item[data-value=\"0.8\"]::before,\n.ql-picker-label[data-value=\"0.8\"]::before {\n content: '0.8'!important;\n}\n\n.ql-picker-item[data-value=\"1.0\"]::before,\n.ql-picker-label[data-value=\"1.0\"]::before {\n content: '1.0'!important;\n}\n\n.ql-picker-item[data-value=\"1.2\"]::before,\n.ql-picker-label[data-value=\"1.2\"]::before {\n content: '1.2'!important;\n}\n.ql-picker-item[data-value=\"1.5\"]::before,\n.ql-picker-label[data-value=\"1.5\"]::before {\n content: '1.5'!important;\n}\n.ql-picker-item[data-value=\"2.0\"]::before,\n.ql-picker-label[data-value=\"2.0\"]::before {\n content: '2.0'!important;\n}\n\n.printContent {\n  display: none;\n\n  @media print {\n    display: block;\n\n    .noPrint {\n      display: none;\n    }\n\n    .x6-graph-svg {\n      position: static !important;\n      left: auto;\n      right: auto;\n      top: auto;\n      bottom: auto;\n    }\n  }\n}\n\n.main-menu {\n  background-color: #1A8D5F;\n\n  .ant-menu-title-content, .ant-menu-title-content > a {\n    color: #fff;\n  }\n\n  .ant-menu-overflow-item, .ant-menu-submenu-title {\n    align-items: center;\n    display: flex;\n  }\n}","@import '~katex/dist/katex.css';\n@import '~nprogress/nprogress.css';\n// @import '~react-grid-layout/css/styles.css';\n// @import '~react-resizable/css/styles.css';\n@import 'styles/index';","table {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.view-form,\n.design-table {\n  table td,\n  table th {\n    border: 1px solid #eee;\n    /* padding:10px; */\n    empty-cells: show;\n  }\n}\n\n.hide-outer-border .view-form-table {\n  tr:first-child > td {\n    border-top: none;\n  }\n  tr:last-child > td {\n    border-bottom: none;\n  }\n\n  tr > td:first-child {\n    border-left: none;\n  }\n\n  tr > td:last-child {\n    border-right: none;\n  }\n}\n\n.d-forms .forms-header, .d-forms .forms-content {\n  tr:first-child > td {\n    border-top: none;\n  }\n\n  tr > td:first-child {\n    border-left: none;\n  }\n\n  tr > td:last-child {\n    border-right: none;\n  }\n}\n",".generate-margin(@n, @i: 0) when (@i =< @n) {\n  .mt-@{i} {\n    margin-top: (@i * 8px) !important;\n  }\n\n  .mb-@{i} {\n    margin-bottom: (@i * 8px) !important;\n  }\n\n  .ml-@{i} {\n    margin-left: (@i * 8px) !important;\n  }\n\n  .mr-@{i} {\n    margin-right: (@i * 8px) !important;\n  }\n\n  .mx-@{i} {\n    margin-left: (@i * 8px) !important;\n    margin-right: (@i * 8px) !important;\n  }\n\n  .my-@{i} {\n    margin-top: (@i * 8px) !important;\n    margin-bottom: (@i * 8px) !important;\n  }\n\n  .m-@{i} {\n    margin: (@i * 8px) !important;\n  }\n\n  .generate-margin(@n, (@i + 1));\n}\n\n.generate-margin(4);\n\n.generate-padding(@n, @i: 0) when (@i =< @n) {\n  .pt-@{i} {\n    padding-top: (@i * 8px) !important;\n  }\n\n  .pb-@{i} {\n    padding-bottom: (@i * 8px) !important;\n  }\n\n  .pl-@{i} {\n    padding-left: (@i * 8px) !important;\n  }\n\n  .pr-@{i} {\n    padding-right: (@i * 8px) !important;\n  }\n\n  .px-@{i} {\n    padding-left: (@i * 8px) !important;\n    padding-right: (@i * 8px) !important;\n  }\n\n  .py-@{i} {\n    padding-top: (@i * 8px) !important;\n    padding-bottom: (@i * 8px) !important;\n  }\n\n  .p-@{i} {\n    padding: (@i * 8px) !important;\n  }\n\n  .generate-padding(@n, (@i + 1));\n}\n\n.generate-padding(4);\n","@width-sm: 544px;\n.container-sm {\n  max-width: @width-sm;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@container-md: 768px;\n.container-md {\n  max-width: @container-md;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@container-lg: 1004px;\n.container-lg {\n  max-width: @container-lg;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@container-xl: 1280px;\n.container-xl {\n  max-width: @container-xl;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.actionRow {\n  display: flex;\n  padding: 5px 10px;\n  justify-content: flex-end;\n}","* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.ant-tabs-tab {\n  .ant-btn-group {\n    button {\n      border: none;\n      outline: none;\n      background: none;\n      box-shadow: none;\n    }\n  }\n}\n\n.ant-tree-iconEle {\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.otree-menu {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.ant-table.ant-table-bordered > .ant-table-title {\n  background: #fafafa;\n}\n\n.ant-btn-sm {\n  font-size: 12px;\n}\n\n.ant-tree-list-holder-inner {\n  display: inline-flex !important;\n  min-width: 100%;\n}\n\n.ant-tree-node-content-wrapper {\n  white-space: nowrap;\n}\n\n.ant-modal-title {\n  white-space: nowrap;\n  max-width: 70%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.orbit-context-menu {\n  .ant-menu-submenu-title, .ant-menu-submenu-title, .ant-menu-item {\n    height: 26px !important;\n    line-height: 26px !important;\n  }\n}",".break-word-table {\n  th,td {\n    word-wrap: break-word;\n  }\n}\n\n.table-mt {\n  margin-top: 16px;\n}\n\n.bordered-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.bordered-table th,\n.bordered-table td {\n  border: 1px solid #eee;\n  padding: 4px;\n  text-align: center;\n}\n\n.bordered-table th {\n  background-color: #fafafa;\n}\n\n.bordered-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.bordered-table.same-color tr:nth-child(even){\n  background-color: inherit !important;\n}","\n.orbit-variable-cell {\n  position: relative;\n  \n  &.manual-var {\n    color: #037C4B;\n  }\n}\n\n.orbit-cell {\n  padding: 0 !important;\n}\n\n.orbit-cell-div {\n  width: 100%;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.orbit-formula-cell {\n  background-color: bisque;\n}\n\n.jtabs-headers-container {\n  display: none !important;\n}\n\n.orbit-variable-cell {\n  background-image: url('/public/svgs/variable-link.svg');\n  background-position: right top;\n  background-repeat: no-repeat;\n}\n\n.formula-cell {\n  border-color: #037C4B;\n}","\n.editableDiv {\n  width: 100%;\n}\n\n.totalFraction {\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  display: inline-block;\n  width: 100px;\n}\n\n.errorStatus {\n  color: red;\n}\n.manualInputRow {\n  color: #1677ff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
